<main id="reset-password" class="h-screen w-screen flex flex-col justify-center">
  <div class=" max-w-sm mx-auto white-card">
    @if (!formSubmitted) {
      <div class="header-wr">
        <img class="mx-auto company-logo" src="../../../../../assets/logos/aricoma-dark.svg"
          [attr.alt]="'LOGIN.LOGO_ALT' | translate">
        <h2 class="text-center">{{ 'RESET_PASSWORD.TITLE' | translate }}</h2>
      </div>
      <div class="form-wr">
        <form [formGroup]="resetPasswordFormGroup" (keydown)="submitOnPressEnter($event)">
          <div class="field-wr">
            <label for="username" class="block text-sm">{{ 'RESET_PASSWORD.USERNAME' | translate }}</label>
            <div class="mt-2">
              <input id="email" name="username" type="text" autocomplete="username" formControlName="username" required class="text-field">
            </div>
          </div>
          @if (successMessage) {
            <p class="text-sm">{{ successMessage }}</p>
          }
          @if (errorMessage) {
            <p class="p-error text-sm">{{ errorMessage }}</p>
          }
          <div class="btn-wr mt-8 mb-6">
            <button class="btn primary-btn w-full" (click)="resetPassword()">{{ 'RESET_PASSWORD.BTN_RESET_PASSWORD' | translate }}</button>
          </div>
        </form>
        <div class="text-center text-sm">
          <a [routerLink]="['/login']" class="font-semibold">{{ 'RESET_PASSWORD.BACK_TO_LOGIN_LINK' | translate }}</a>
        </div>
      </div>
    }
    @if (formSubmitted) {
      <div class="header-wr">
        <img class="mx-auto company-logo" src="../../../../../assets/logos/aricoma-dark.svg"
          [attr.alt]="'LOGIN.LOGO_ALT' | translate">
        <h2 class="text-center">{{ 'RESET_PASSWORD_SUCCESS.TITLE' | translate }}</h2>
      </div>
      <div class="row mt-2">
        <p class="text-sm text-center">{{ 'RESET_PASSWORD_SUCCESS.DESCRIPTION' | translate }}</p>
        <div class="btn-wr mt-8 mb-2">
          <button class="btn primary-btn w-full" (click)="backToLogin()">{{ 'RESET_PASSWORD_SUCCESS.BACK_TO_LOGIN_LINK' | translate }}</button>
        </div>
      </div>
    }
  </div>
</main>
